
// ****************************** Import From AWS Amplify ******************************** //

import '/src/amplify-config';

// ****************************** Import CSS ******************************** //

import "./chess.css";

// ****************************** Import Images ******************************** //

import "/src/assets/chess-tournaments/1st-annual-chess-tournament-graphic.png"
import "/src/assets/chess-tournaments/2nd-Youth-Chess-Tournament.jpg"


import "/src/assets/chess-tournaments/from-pawns-to-kings-logo-short.png"

import "/src/assets/sponsor-logos/100-black-men-logo.jpeg"
import "/src/assets/sponsor-logos/gcs-wordmark.png"
import "/src/assets/sponsor-logos/mcdonalds-palmaccio-logo.jpg"
import "/src/assets/sponsor-logos/jim-n-nicks-logo.png"
import "/src/assets/sponsor-logos/sav-ghost-pirates.png"
import "/src/assets/sponsor-logos/dairy-queen-logo.png"

import "/src/assets/backgrounds/i-is-we-chess-background.jpg"


// ************************ Import Images - Nov 2025 Chess Tournament ************************** //

import "/src/assets/chess-tournaments/nov-2025-tournament/nov-2025-winners.jpg"

import "/src/assets/chess-tournaments/nov-2025-tournament/nov-2025-practice-1.jpg"
import "/src/assets/chess-tournaments/nov-2025-tournament/nov-2025-practice-2.jpg"

import "/src/assets/chess-tournaments/nov-2025-tournament/nov-2025-players-1.jpg"
import "/src/assets/chess-tournaments/nov-2025-tournament/nov-2025-players-2.jpg"
import "/src/assets/chess-tournaments/nov-2025-tournament/nov-2025-players-3.jpg"
import "/src/assets/chess-tournaments/nov-2025-tournament/nov-2025-players-4.jpg"

import "/src/assets/chess-tournaments/nov-2025-tournament/nov-2025-ghost-pirates-1.jpg"
import "/src/assets/chess-tournaments/nov-2025-tournament/nov-2025-ghost-pirates-2.jpg"
import "/src/assets/chess-tournaments/nov-2025-tournament/nov-2025-amon-natasha-ghost-1.jpg"

import "/src/assets/chess-tournaments/nov-2025-tournament/nov-2025-face-painting-1.jpg"
import "/src/assets/chess-tournaments/nov-2025-tournament/nov-2025-face-painting-2.jpg"

import "/src/assets/chess-tournaments/nov-2025-tournament/nov-2025-sponsors.jpg"

// **************************** Add Top Nav & Footer ************************** //

import '/src/nav-header-footer/nav-header-footer.js';
import '/src/nav-header-footer/nav-header-footer.css';

// ************ Add Email Signup *************** //

import '/src/email-signups/youth-chess-email-list/youth-chess-email-list.js';


